import { put, call, take, fork } from 'redux-saga/effects'
import { questionCloneService } from '../../api/question'
import { questionCloneSuccess } from '../../reducers/question/action'
import { QUESTION_CLONE } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionCloneFlow(payload) {
  try {
    const { ids, callback } = payload
    const response = yield call(questionCloneService, ids)

    yield put(questionCloneSuccess(response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionCloneWatcher() {
  while (true) {
    const action = yield take(QUESTION_CLONE)
    const { payload } = action

    yield fork(generalSaga, questionCloneFlow, payload)
  }
}
